import {
  UPLOAD_DOCUMENT_FAIL,
  UPLOAD_DOCUMENT_SUCCESS,
  DELETE_DOCUMENT
 
} from '../actions/types';

const initialState = {
  document :{},
};

export default function uploadDocument(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_DOCUMENT_SUCCESS:
      //console.log("actionData",action.data)
      return Object.assign({}, state, {
        document:action.data,
   
      })
    case DELETE_DOCUMENT:
    return Object.assign({}, state, {
      document: {},
     
    })
    case UPLOAD_DOCUMENT_FAIL:
    return action.payload;
    default:
      return state
  }
}